import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import {formattedDateTime} from "../../../../utils/helper";


type RunningTrip = {
    id: string;
    fare: number;
    startTime: string;
    expectedEndTime: string;
    upPoint: string;
    endPoint: string;
    distance: number;
    driverName: string;
    carNumber: string;
};

type RunningTripsProps = {
    trips: RunningTrip[];
};

const RunningTrips: React.FC<RunningTripsProps> = ({ trips }) => {
    return (
        <DataTable
            className="pt-2"
            value={trips}
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20, 50]}
            stripedRows
        >
            <Column field="fare" header="Fare" body={row => `৳${row.fare}`} />
            <Column field="startTime" header="Start Time" body={rowData => formattedDateTime(rowData.startTime, true)} />
            <Column field="expectedEndTime" header="Expected End Time" body={rowData => formattedDateTime(rowData.expectedEndTime, true)} />
            <Column field="upPoint" header="Up Point" />
            <Column field="endPoint" header="End Point" />
            <Column field="distance" header="Distance" body={row => `${row.distance} km`} />
            <Column field="driverName" header="Driver Name" />
            <Column field="carNumber" header="Car Number" />
        </DataTable>
    );
};

export default RunningTrips;
